import React, { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { LANDING } from '@/constants/testIds';

const Testimonials = () => {
    const [playing, setPlaying] = useState(false);
    const videoRef = useRef(null);

    const handlePlay = () => {
        setPlaying(true);
        requestAnimationFrame(() => videoRef.current?.play());
    };

    return (
        <section
            id="testimonios"
            data-testid={LANDING.testimonialSection}
            className="relative py-16 md:py-24 border-t border-white/10 overflow-hidden"
        >
            <div
                className="pointer-events-none absolute -bottom-40 -left-20 h-[480px] w-[480px] rounded-full"
                style={{ background: 'radial-gradient(closest-side, rgba(225,29,72,0.12), transparent 70%)' }}
            />
            <div className="relative mx-auto max-w-[1440px] px-6 md:px-10">
                <div className="grid grid-cols-12 gap-8 md:gap-12 items-center">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7 }}
                        className="col-span-12 md:col-span-6 order-2 md:order-1"
                    >
                        <div className="eyebrow-brand mb-6">Testimonios</div>
                        <h2 className="font-display text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl">
                            Quienes ya fueron,{' '}
                            <span className="italic-accent text-[color:var(--brand)] font-normal">lo cuentan mejor.</span>
                        </h2>
                        <p className="mt-6 text-white/70 leading-relaxed max-w-[52ch]">
                            Jorge Mario Ríos participó en la Misión FITUR 2025 y volvió a casa
                            con tres negocios importantes cerrados. Un minuto que vale más que mil promesas.
                        </p>
                        <div className="mt-8 flex items-center gap-4">
                            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[color:var(--brand)]/15 border border-[color:var(--brand)]/40 font-display text-[color:var(--brand)] text-lg">
                                JR
                            </span>
                            <div>
                                <div className="text-white font-semibold">Jorge Mario Ríos</div>
                                <div className="text-white/50 text-sm">Colombian Adventure · Testimonio 1:10 min</div>
                            </div>
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: '-80px' }}
                        transition={{ duration: 0.8 }}
                        className="col-span-12 md:col-span-6 order-1 md:order-2 flex justify-center"
                    >
                        <div
                            className="relative w-full max-w-[340px] md:max-w-[380px] border border-white/12 bg-black overflow-hidden rounded-2xl"
                            style={{ boxShadow: '0 40px 90px -30px rgba(0,0,0,0.7)' }}
                        >
                            <div className="relative aspect-[9/16]">
                                <video
                                    ref={videoRef}
                                    data-testid={LANDING.testimonialPlayer}
                                    className="h-full w-full object-cover"
                                    poster="/assets/testimonio-jorge-rios-poster.jpg"
                                    preload="none"
                                    playsInline
                                    controls={playing}
                                >
                                    <source src="/assets/testimonio-jorge-rios.mp4" type="video/mp4" />
                                    <source src="/assets/testimonio-jorge-rios.webm" type="video/webm" />
                                </video>
                                {!playing && (
                                    <button
                                        type="button"
                                        data-testid={LANDING.testimonialPlay}
                                        onClick={handlePlay}
                                        className="group absolute inset-0 flex items-center justify-center bg-gradient-to-t from-black/70 via-black/25 to-black/10 transition-colors duration-500 hover:from-black/60"
                                        aria-label="Reproducir testimonio de Jorge Mario Ríos"
                                    >
                                        <span className="flex flex-col items-center gap-4">
                                            <span className="relative flex h-16 w-16 md:h-20 md:w-20 items-center justify-center rounded-full bg-[color:var(--brand)] transition-transform duration-500 group-hover:scale-110">
                                                <span className="absolute inline-flex h-full w-full rounded-full bg-[color:var(--brand)] opacity-50 animate-ping" />
                                                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" className="relative ml-1">
                                                    <path d="M6 4.5v15l13-7.5-13-7.5z" fill="white" />
                                                </svg>
                                            </span>
                                            <span className="text-[11px] uppercase tracking-[0.28em] text-white/85 font-semibold">
                                                Ver testimonio
                                            </span>
                                        </span>
                                    </button>
                                )}
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
